<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!-- 合同列表区 start -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['cont:contract:list']" @load="handleContract" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item,index) in list" :key="index" @click="toContractDetails(item)">
        <div class="flex-c-center" v-if="item">
          <div>
            <div class="custName-wrap">
              <div class="custName">
                {{ item.custName }}
              </div>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.contractType">{{ contractTypeFormat2(item.contractType) }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.contractStatus">{{ contractStatusFormat2(item.contractStatus) }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.payMode">{{ payModeFormat2(item.payMode) }}</van-tag>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.contractMoney">合同金额：{{ item.contractMoney }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.signTime">签约日期：{{ item.signTime | timeFormat }}</van-tag>
            </div>
          </div>
          <van-icon name="arrow" size="16" class="arrow-color" @click="toContractDetails(item)" />
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- 合同列表区 end -->
    <!--添加合同信息-->
    <!-- <van-dialog v-model="show" title="添加合同信息" :beforeClose="editContractBeforeClose" close-on-click-overlay>
      <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap">
        <van-cell-group>
          <van-field v-model="form.contractName" label="合同标题" :rules="[{ required: true }]" required />
          <van-field v-model="form.contractNum" label="合同编号" :rules="[{ required: true }]" required />
          <van-field v-model="form.contractMoney" label="合同金额" :rules="[{ required: true}]" required />
          <van-field v-model="form.allReturnedMoney" label="合同回款总金额" :rules="[{ required: true}]" required />
          <van-field v-model="form.noReturnedMoney" label="合同未回款金额" :rules="[{ required: true }]" required />
          <van-field readonly clickable v-model="form.contractTypeName" @click="showPicker('contractType')" label="合同类型" required />
          <van-field readonly clickable v-model="form.contractStatusName" @click="showPicker('contractStatus')" label="合同状态" />
          <van-field readonly clickable v-model="form.payModeName" @click="showPicker('payMode')" label="支付方式" required />
          <van-field v-model="form.startTime" readonly clickable name="calendar" label="开始时间" placeholder="点击选择日期" @click="showStartCalendar = true" required />
          <van-field v-model="form.endTime" readonly clickable name="calendar" label="结束时间" placeholder="点击选择日期" @click="showEndCalendar = true" required />
          <van-field v-model="form.signTime" readonly clickable name="calendar" label="签约日期" placeholder="点击选择日期" @click="showSignCalendar = true" required />
          <van-field v-model="form.custSignedUser" label="对方签约人" :rules="[{ required: true }]" required />
          <van-field v-model="form.mySignedUser" label="我方签约人" :rules="[{ required: true }]" required />
          <van-field name="rate" label="电子合同">
            <template #input>
              <van-uploader v-model="fileList" :after-read="uploadContractFiles" :max-count="1" :max-size="52428800" upload-text="电子合同" required>
              </van-uploader>
            </template>
          </van-field>
          <van-field name="rate" label="附件1">
            <template #input>
              <van-uploader v-model="fileList1" :after-read="uploadContractFiles1" :max-count="1" :max-size="52428800" upload-text="附件1">
              </van-uploader>
            </template>
          </van-field>
          <van-field name="rate" label="附件2">
            <template #input>
              <van-uploader v-model="fileList2" :after-read="uploadContractFiles2" :max-count="1" :max-size="52428800" upload-text="附件2">
              </van-uploader>
            </template>
          </van-field>
          <van-field v-model="form.remark" label="备注" />
          <van-field v-model="form.content" rows="2" type="textarea" label="合同内容" />
        </van-cell-group>
      </van-form>
    </van-dialog> -->
    <!--客户搜索-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <!-- 日期选择器 -->
    <van-calendar v-model="showStartCalendar" :min-date="minDate" type="single" @confirm="onStartCalendarConfirm" />
    <van-calendar v-model="showEndCalendar" :min-date="minDateStart" type="single" @confirm="onEndCalendarConfirm" />
    <van-calendar v-model="showSignCalendar" :min-date="minDate" type="single" @confirm="onSignCalendarConfirm" />
    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
  </div>
</template>
<script>
import moment from "moment";
import {
  Search,
  List,
  Cell,
  Button,
  Tag,
  Dialog,
  Area,
  Toast,
  Icon,
  Field,
  Col,
  Row,
  CellGroup,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Grid,
  GridItem,
  Tab,
  Uploader,
  Tabs,
  Form,
  Calendar,
} from "vant";
import { listContract } from "@/api/fina/noinvoice";
import { ucloudUpFileToContract } from "@/api/system/common";
import { getDicts } from "@/api/system/dict/data";
import SearchComponent from "@/components/common/Search";
import EmptyComponent from "@/components/common/Empty";
import TotalComponent from "@/components/common/Total";
import SearchPop from '../../cont/components/contract/SearchPop'
export default {
  components: {
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Form.name]: Form,
    [Uploader.name]: Uploader,
    [Calendar.name]: Calendar,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    SearchComponent,
    EmptyComponent,
    TotalComponent,
    SearchPop
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      isEmpty: false,
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
      },
      total: 0,
      loading: false,
      finished: false,
      showFilterPop: false,
      fileList: [],
      fileList1: [],
      fileList2: [],
      list: [],
      type: "add",
      show: false,
      searchParams: {
        visible: false,
      },
      searchValue: "",
      // 状态数据字典
      statusOptions: this.$store.state.dictOptions.status || [],
      // 客户类型字典
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      //投放类型列表
      launchTypeOptions: this.$store.state.dictOptions.custOrderLaunchType || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      active: 0,
      // 列表
      activeName: "active_nocontract",
      form: {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      //修改主体框架标题
      document.title = "FINA-开发票";
      await this.handleContract();
    },
    contractTypeFormat2(contractType) {
      return this.selectDictLabel(this.contractTypeOptions, contractType);
    },
    contractStatusFormat2(contractStatus) {
      return this.selectDictLabel(this.contractStatusOptions, contractStatus);
    }, 
    //支付方式字典翻译
    payModeFormat2(payMode) {
      return this.selectDictLabel(this.payModeOptions, payMode);
    },
    payModeFormat(row, column) {
      return this.selectDictLabel(this.payModeOptions, row.payMode);
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + "-" + month + "-" + day;
    },
    onStartCalendarConfirm(data) {
      this.contractForm.startTime = this.formatDate(data);
      this.showStartCalendar = false;
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.form.endTime = this.formatDate(data);
      this.showEndCalendar = false;
    },
    onSignCalendarConfirm(data) {
      this.form.signTime = this.formatDate(data);
      this.showSignCalendar = false;
    },
    // 根据子组件search传值过来的data，就是searchValue
    // queryContractList(data) {
    //   this.queryParams.custName = this.searchValue = data;
    //   this.list = [];
    //   this.handleContract();
    // },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      console.log('handelSearch', data);
      this.resetQuery()
      this.queryParams.custName = this.searchValue = data;
      this.queryOrderList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      console.log('handleFqueryFilter', data);
      let query = this.queryParams;
      this.queryParams = { ...query, ...data }
      this.queryOrderList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    queryOrderList() {
      this.list = [];
      this.queryParams.pageNum = 1
      this.handleContract();
    },
    // 返回布尔值
    beforeRead(file) {
      if (file.type !== "pdf") {
        Toast("请上传 pdf 格式图片");
        return false;
      }
      return true;
    },
    // 返回布尔值
    beforeFileRead(file) {
      if (file.type !== "pdf") {
        Toast("请上传 pdf 格式图片");
        return false;
      }
      return true;
    },
    toContractDetails(item) {
      this.$router.push({
        name: "contractdetail",
        query: {
          id: item.contractId,
          verifyStatus: item.verifyStatus,
          contractSource: item.contractSource,
          isInvoice: true
        },
      });
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "contractType") {
        this.picker.columns = this.contractTypeOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "contractStatus") {
        this.picker.columns = this.contractStatusOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "payMode") {
        this.picker.columns = this.payModeOptions.map((ele) => ele.dictLabel);
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "contractType") {
        this.form.contractType = this.contractTypeOptions[index].dictValue;
        this.form.contractTypeName = this.contractTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "contractStatus") {
        this.form.contractStatus = this.contractStatusOptions[index].dictValue;
        this.form.contractStatusName =
          this.contractStatusOptions[index].dictLabel;
      }
      if (this.picker.formKey === "payMode") {
        this.form.payMode = this.payModeOptions[index].dictValue;
        this.form.payModeName = this.payModeOptions[index].dictLabel;
      }
      this.picker.visible = false;
    },
    pickerCancel() {
      this.picker.visible = false;
    },
    //修改合同
    // async editContractBeforeClose(type, done) {
    //   if (type === "confirm") {
    //     try {
    //       await this.$refs["form"].validate();
    //       addOtherContract(this.form).then((response) => {
    //         Toast.success("添加成功");
    //         this.show = false;
    //         this.otherConTab();
    //       });
    //       done();
    //     } catch (err) {
    //       return done(false);
    //     }
    //     return done(false);
    //   } else {
    //     return done();
    //   }
    // },
    uploadContractFiles(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.contractFile = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles1(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.annexOne = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles2(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.form.annexTwo = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    pickerChange() { },
    confirm() {
      let api = this.type !== "add" ? updateContract : addContract;
      api(this.form).then((response) => {
        let msg = this.type !== "add" ? "修改成功" : " 新增成功";
        Toast(msg);
        this.dialogVisible = false;
        this.failConTab();
      });
    },
    async handleContract() {
      this.loading = true;

      const res = await listContract(this.queryParams);
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        }
        this.list = this.list.concat(res.rows);
        this.queryParams.pageNum += 1;
        this.loading = false;
        this.total = res.total;
        this.finished = this.list.length >= res.total;
        this.showFilterPop = false
      }
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: "1",
        contractType: null,
        contractStatus: null,
        payMode: null,
        hkStatus: null,
        verifyStatus: "1",
        contractMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        status: null,
      };
    },
    reset() {
      this.form = {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: null,
        contractMoney: null,
        allReturnedMoney: null,
        noReturnedMoney: null,
        startTime: null,
        endTime: null,
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      };
    },
  },
};
</script>
